import React from "react";
import { ProductAvailabilityCode } from "../models/models";
import { Box, ThemeProvider, createTheme } from "@mui/material";
import moment from "moment";
import useTranslation from "../../../shared/hooks/useTranslation";

export interface StockItemDetailsAvailabilityProps {
  availabilityCode: ProductAvailabilityCode;
}

const StockItemDetailsAvailability = ({ availabilityCode }: StockItemDetailsAvailabilityProps) => {
  const { translate } = useTranslation("inventory");

  const getTitle = () => {
    return availabilityCode === ProductAvailabilityCode.inStock ? translate("inStock") : translate("out");
  };

  const getColor = () => {
    return availabilityCode === ProductAvailabilityCode.inStock ? "#3EA293" : "#F23E3E";
  };

  const getDeliveryTerm = () => {
    switch (availabilityCode) {
      case ProductAvailabilityCode.inStock:
        return translate("shipBy", { date: moment().format("D.M.yyyy") });
      case ProductAvailabilityCode.in7Days:
        return translate("readyIn7Days");
      case ProductAvailabilityCode.in14Days:
        return translate("readyIn14Days");
      case ProductAvailabilityCode.in1Month:
        return translate("readyIn1Month");
    }
  };

  const theme = createTheme({});

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          padding: "5px",
          border: `1px solid ${getColor()}`,
          borderRadius: "6px",
          display: "flex",
          alignItems: "center",
          width: "max-content"
        }}
      >
        <span
          className="text-14-bold uppercase mr-3"
          style={{ color: getColor() }}
        >
          {getTitle()}
        </span>
        <span className="text-12-medium">{getDeliveryTerm()}</span>
      </Box>
    </ThemeProvider>
  );
};

export default StockItemDetailsAvailability;
